export const SearchIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M11.5 3C6.80558 3 3 6.80558 3 11.5C3 16.1944 6.80558 20 11.5 20C13.4869 20 15.3145 19.3183 16.7618 18.176L20.3895 21.8037L21.8037 20.3895L18.176 16.7618C19.3183 15.3145 20 13.4869 20 11.5C20 6.80558 16.1944 3 11.5 3ZM5 11.5C5 7.91015 7.91015 5 11.5 5C15.0899 5 18 7.91015 18 11.5C18 15.0899 15.0899 18 11.5 18C7.91015 18 5 15.0899 5 11.5Z"
                  fill="#FCFCFC" fillOpacity="0.8"/>
        </svg>
    )
}